import React from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { catalogBibShape, ugcVideoShape, libraryShape } from '@bibliocommons/bc-prop-types';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectCatalogBibEntities, selectVideoEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import RelationshipsActions from 'app/actions/RelationshipsActions';
import { DocumentHeadContainer } from 'app/components/shared/DocumentHead';
import NotFoundPage from 'app/components/NotFoundPage/NotFoundPage';
import VideoPage from './VideoPage';

export function VideoPageContainer(props) {
  const { catalogBib, video, intl } = props;
  if (!video) {
    return <NotFoundPage />;
  }

  const title = catalogBib.getIn(['brief', 'title']);
  const pageTitle = intl.formatMessage({ id: 'video_page_title' }, { title });

  return (
    <>
      <DocumentHeadContainer pageTitle={pageTitle} />
      <VideoPage {...props} />
    </>
  );
}

VideoPageContainer.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  currentUserId: PropTypes.number,
  relationshipsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  video: ugcVideoShape,
  currentLibrary: libraryShape.isRequired
};

const mapStateToProps = state => {
  const video = state.getIn(['ugc', 'video']);
  const videoEntity = selectVideoEntities(state).get(video.get('id', '').toString());

  return {
    catalogBib: selectCatalogBibEntities(state).get(videoEntity.get('metadataId')),
    currentUserId: selectCurrentUser(state)?.get('id') ?? null,
    currentLibrary: selectCurrentLibrary(state),
    video: videoEntity
  };
};

const mapDispatchToProps = dispatch => ({
  relationshipsActions: bindActionCreators(RelationshipsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(VideoPageContainer));
